/**
 * Componente reutilizable PlayerInformation
 * Muestra una imagen de bandera y el nombre de un jugador.
*/
export default function PlayerInformation({ image, name, className }) {
  let ima = String(image).length > 3 || String(image).length === 0;
  const flagClass = `flag-tenis bandera-${!ima ? image : "null"}`;

  return (
    <div className={className}>
      <div className={flagClass}></div>
      <p>{name}</p>
    </div>
  );
}